import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { GETTING_STUDENTS, GET_STUDENTS, SET_SUCCESS, STUDENTS_ERROR, UPDATED_STUDENT, UPDATING_STUDENT } from "../types"

export const updateStudent = (studentId, applicationPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_STUDENT,
            payload: true
        })
        const response = await axios.patch(`${baseUrl}/students/${studentId}`, applicationPayload, { headers })

        dispatch({
            type: SET_SUCCESS,
            payload: "Student updated successfully"
        })
        
        dispatch({
            type: UPDATED_STUDENT,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: STUDENTS_ERROR,
            error
        })
    }
}

export const fetchStudents = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/students?expand=class.class,parent`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if((page || page === 0) && page !== '') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if((perPage || perPage === 0) && perPage !== '') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_STUDENTS,
            payload: true
        })

        const response = await axios.get(url, { headers })

        dispatch({
            type: GET_STUDENTS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: STUDENTS_ERROR,
            error
        })
    }
}

// export const clearCreatedApplication = () => async (dispatch) => { 
//     dispatch({
//         type: CREATE_APPLICATION,
//         payload: null
//     })
// }

export const clearUpdatedStudent = () => async (dispatch) => { 
    dispatch({
        type: UPDATED_STUDENT,
        payload: null
    })
}